<div class="modal-content modal-content-full-height">
    <div class="modal-header bg-warning">
        <h5 class="modal-title" id="landused">การใช้ประโยชน์ในแปลงที่ดิน</h5>
        <button type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close"  (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="background:#F0F2E1;padding:10px;">
        <div class="row p-l-20 p-r-20">
            <div class="col-lg-12">
                <div class="badge badge-primary h6">การใช้ประโยชน์ของที่ดิน</div>
                <div class="col-md-12 card" style="background: #c4c9da">

                    <div class="row p-t-5">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label>ประเภทการใช้ประโยชน์ที่ดิน::</label>
                                    <select class="form-control" [(ngModel)]="landused.lu_type" (change)="checkDuplicate()">
                                        <option value="1">1 - เกษตรกรรม</option>
                                        <option value="2">2 - ที่อยู่อาศัย</option>
                                        <option value="3">3 - อื่นๆ (ไม่ใช่เกษตรกรรมหรือที่อยู่อาศัย)</option>
                                        <option value="4">4 - ทิ้งไว้ว่างเปล่า/รกร้าง</option>
                                        <option value="444">4 - ทิ้งไว้ว่างเปล่า/รกร้าง 3 ปี</option>
                                        <option value="5">5 - ใช้ประโยชน์หลายประเภท</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label>เนื้อที่การใช้ประโยชน์ (ไร่-งาน-ตร.วา)::</label>
                                    <div class="row col-md-12">
                                        <div class="col-sm-4 p-r-0 p-l-0">
                                            <input type="text" class="form-control p-l-2 p-r-2 align-center"
                                                [(ngModel)]="landused.u_r" (keyup)="callArea()">
                                        </div>
                                        <label class="col-sm-1 col-form-label p-l-0 p-r-0 align-center">-</label>
                                        <div class="col-sm-2 p-l-0 p-r-0">
                                            <input type="text" class="form-control"
                                                class="form-control p-l-2 p-r-2 align-center"
                                                [(ngModel)]="landused.u_y" (keyup)="callArea()">
                                        </div>
                                        <label class="col-sm-1 col-form-label align-center">-</label>
                                        <div class="col-sm-4 p-l-0 p-r-3">
                                            <input type="text" class="form-control"
                                                class="form-control p-l-2 p-r-2 align-center"
                                                [(ngModel)]="landused.u_w" (keyup)="callArea()">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="landused.lu_type == 2">
                                <div class="form-group col-md-8">
                                    <label>ใช้สำหรับอยู่อาศัยประเภทใดบ้าง::</label>
                                    <select class="form-control" [(ngModel)]="landused.sub_lu_type" (change)="checkDuplicate()">
                                        <option value="2">2-1 - ที่อยู่อาศัย - หลังหลัก และ หลังอื่นๆ</option>
                                        <option value="3">2-2 - ที่อยู่อาศัย - หลังหลัก(ไม่ใช่เจ้าของกรรมสิทธิ์ที่ดิน)</option>
                                        <option value="4">2-3 - ที่อยู่อาศัย - หลังอื่นๆ</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label>ผู้ทำประโยชน์ ::</label>
                                    <select class="form-control" [(ngModel)]="landused.owner_used">
                                        <option value="1">ใช้เอง</option>
                                        <option value="2">ให้เช่า</option>
                                        <option value="3">ให้บุคคลอื่นทำประโยชน์</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label>ชื่อ-สกุล ผู้ทำประโยชน์ ::</label>
                                    <input type="text" class="form-control" class="form-control"
                                        [(ngModel)]="landused.used_by">
                                </div>
                            </div>
                            
                            <div class="row" *ngIf="landused.lu_type ==1">
                                <div class="form-group col-md-6">
                                    <label>การเกษตรที่ทำ::</label>
                                    <select class="form-control" [(ngModel)]="landused.agri_type">
                                        <option value="1">1 - ปลูกข้าว</option>
                                        <option value="2">2 - ข้าวโพด</option>
                                        <option value="3">3 - อ้อย</option>
                                        <option value="3">4 - มันสำปะหลัง</option>
                                        <option value="4">5 - ไม้ล้มลุกอื่นๆ</option>
                                        <option value="4">6 - ยางพารา</option>
                                        <option value="4">7 - ปาล์ม</option>
                                        <option value="4">8 - ไม้ยืนต้นอื่นๆ</option>
                                        <option value="4">9 - เลี้ยงสัตว์ - ไก่</option>
                                        <option value="4">10 - เลี้ยงสัตว์ - สุกร</option>
                                        <option value="4">11 - เลี้ยงสัตว์ - วัว</option>
                                        <option value="4">12 - เลี้ยงสัตว์ - ปลา</option>
                                        <option value="4">13 - เลี้ยงสัตว์อื่นๆ</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label>อื่นๆ::</label>
                                    <input type="text" class="form-control" class="form-control"
                                        [(ngModel)]="landused.agri_other">
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="badge badge-primary p-a-8 h6 m-0">รูปภาพการใช้ประโยชน์ในแปลงที่ดิน</div>
                                    <div class="badge badge-success col-md-2 p-a-8 h5" style="cursor:pointer;">เพิ่ม/จัดการรูปภาพ</div>                                    
                                    <div class="card" id="map" style="min-height:300px;">
                                    <div class="col-md-6">
                                        
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="row">
                                <div class="badge badge-primary h6"><span>กรณีมีสิ่งปลูกสร้างในการใช้ประโยชน์</span>
                                </div>
                                <div class="badge badge-success h6" (click)="createBuilding()" [hidden]="!landused.luid">
                                    เพิ่มรายการสิ่งปลูกสร้าง</div>
                                <ag-grid-angular style="width: 100%; height: 250px;" id="myGrid" class="ag-theme-balham"
                                    [columnDefs]="buildingColumn" [rowData]="buildingRow"
                                    (rowClicked)='editBuilding($event)'
                                    (gridReady)="onGridReady($event)">
                                </ag-grid-angular>
                            </div>
                            <div class="row p-t-5">
                                <div class="form-group col-md-12 p-l-0 p-r-0">
                                    <div class="badge badge-primary p-a-8 h5">หมายเหตุ</div>
                                    <textarea class="form-control" style="min-height:150px;"
                                        [(ngModel)]="landused.lu_notes"></textarea>
                                </div>

                            </div>

                            <div class="row p-t-5">
                                <div class="card-footer top text-center col-md-12">
                                    <a class="btn btn-success" href="javascript:void(0);"
                                        (click)="saveLandused()">บันทึกข้อมูล</a>
                                    <a class="btn btn-danger" href="javascript:void(0);" (click)="remove()"
                                        *ngIf="landused.luid">ลบการใช้ประโยชน์</a>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>

            </div>


        </div>


    </div>

</div>
